import ConfirmDialog from '../modal/confirm-modal';

/**
 * An object where all modals are registered with a unique id. Every modal that needs to be displayed or hidden using modal container
 * should be registered here.
 */
const modalDialogList = ({
  confirm: ConfirmDialog,
});

export default modalDialogList;
